exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-title[data-v-42db5434] {\n  margin-bottom: 20px;\n}\nh2[data-v-42db5434] {\n  font-weight: normal;\n  margin: 12px 0px 0px;\n}\n", ""]);

// exports
